const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: SDOF Torsional System — Anatomy ────────────────────
function DiagramSDOFTorsion() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  // Draw a shaft cross-section as ellipse
  const shaftDraw = (cx, cy, rx, ry, angle, col) => {
    // Twisted shaft segment shown as parallelogram-style lines
    const pts = [];
    for (let i = 0; i <= 12; i++) {
      const t = i / 12;
      const x = cx - 80 + t * 160;
      const twist = Math.sin(t * Math.PI) * angle;
      pts.push(`${x},${cy + twist}`);
    }
    return pts.join(' ');
  };

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>SDOF Torsional System — Physical Model and Equation of Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ta1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="ta2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
          <marker id="ta3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#888"/>
          </marker>
        </defs>

        {/* ── Panel 1: Physical layout ── */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">SDOF Torsional Oscillator</text>

        {(() => {
          const cx = 10 + PW/2, cy = 145;

          // Fixed wall (left)
          const wallX = 48;
          // Shaft from wall to disk
          const shaftX1 = wallX + 4, shaftX2 = cx - 40;
          const shaftY = cy, shaftR = 8;

          return (
            <>
              {/* Fixed wall */}
              <rect x={wallX-10} y={shaftY-50} width={14} height={100} fill="#999" rx={2}/>
              {[-40,-24,-8,8,24,40].map(dy=>(
                <line key={dy} x1={wallX-10} y1={shaftY+dy} x2={wallX-22} y2={shaftY+dy+12}
                  stroke="#bbb" strokeWidth="1.5"/>
              ))}
              <text x={wallX-26} y={shaftY-54} fontSize="10" fill="#888" textAnchor="middle">Fixed</text>

              {/* Shaft body */}
              <rect x={shaftX1} y={shaftY-shaftR} width={shaftX2-shaftX1} height={shaftR*2}
                rx={shaftR} fill="#ddd" stroke="#999" strokeWidth="1.5"/>
              {/* Shaft twist lines */}
              {[0.25,0.5,0.75].map((t,i)=>{
                const x = shaftX1 + t*(shaftX2-shaftX1);
                const twist = [-6,0,6][i];
                return <line key={i} x1={x} y1={shaftY-shaftR} x2={x+twist} y2={shaftY+shaftR}
                  stroke="#aaa" strokeWidth="1" strokeDasharray="2,2"/>;
              })}

              {/* Torsional spring symbol (coil) around shaft */}
              {[0,1,2,3,4].map(i=>{
                const x = shaftX1 + 20 + i * 22;
                return (
                  <g key={i}>
                    <path d={`M${x},${shaftY-shaftR-8} A 10 10 0 0 1 ${x+10},${shaftY-shaftR-8}`}
                      fill="none" stroke="#c0392b" strokeWidth="2"/>
                    <path d={`M${x+10},${shaftY+shaftR+8} A 10 10 0 0 1 ${x},${shaftY+shaftR+8}`}
                      fill="none" stroke="#c0392b" strokeWidth="2"/>
                  </g>
                );
              })}
              <text x={(shaftX1+shaftX2)/2} y={shaftY-shaftR-18} textAnchor="middle"
                fontSize="11" fill="#c0392b" fontWeight="700">kt (torsional stiffness)</text>

              {/* Disk (moment of inertia J) */}
              <ellipse cx={cx} cy={cy} rx={36} ry={50} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2.5"/>
              {/* Disk radial lines */}
              {[0,60,120,180,240,300].map(deg=>{
                const rad = deg * Math.PI/180;
                return <line key={deg} x1={cx} y1={cy}
                  x2={cx+32*Math.cos(rad)} y2={cy+45*Math.sin(rad)}
                  stroke="#f0cece" strokeWidth="1"/>;
              })}
              <text x={cx} y={cy-6} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">J</text>
              <text x={cx} y={cy+10} textAnchor="middle" fontSize="10" fill="#555">polar inertia</text>

              {/* Damper ct */}
              {(() => {
                const dx = cx+50, dy = cy;
                return (
                  <>
                    <line x1={cx+36} y1={dy} x2={dx} y2={dy} stroke="#e07b00" strokeWidth="2"/>
                    <rect x={dx} y={dy-10} width={22} height={20} fill="#fff9e6"
                      stroke="#e07b00" strokeWidth="2" rx={3}/>
                    <line x1={dx+22} y1={dy} x2={dx+46} y2={dy} stroke="#e07b00" strokeWidth="2"/>
                    <rect x={dx+46} y={dy-18} width={6} height={36} fill="#e07b00" rx={1}/>
                    <text x={dx+11} y={dy-16} textAnchor="middle" fontSize="10"
                      fill="#e07b00" fontWeight="700">ct</text>
                  </>
                );
              })()}

              {/* Applied torque arrow */}
              <path d={`M ${cx+12},${cy-55} A 45 55 0 0 1 ${cx+12},${cy+55}`}
                fill="none" stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#ta2)"/>
              <text x={cx+62} y={cy-42} fontSize="11" fill="#2E75B6" fontWeight="700">T(t)</text>
              <text x={cx+62} y={cy-28} fontSize="10" fill="#555">applied torque</text>

              {/* Twist angle annotation */}
              <path d={`M ${cx-12},${cy-55} A 40 50 0 0 0 ${cx-36},${cy-12}`}
                fill="none" stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,2"
                markerEnd="url(#ta1)"/>
              <text x={cx-52} y={cy-36} fontSize="10" fill="#27ae60" fontWeight="700">θ(t)</text>
              <text x={cx-52} y={cy-22} fontSize="9" fill="#555">twist angle</text>

              {/* Labels */}
              <text x={shaftX1+10} y={shaftY+shaftR+22} fontSize="9.5" fill="#999">L, G, Ip → kt = GIp/L</text>
            </>
          );
        })()}

        {/* Formula box */}
        <rect x={14} y={H-84} width={PW-20} height={70} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={20} y={H-70} fontSize="11" fill="#7B0D0D" fontWeight="700">Equation of Motion:</text>
        <text x={20} y={H-54} fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">J·θ̈ + ct·θ̇ + kt·θ = T(t)</text>
        <text x={20} y={H-38} fontSize="10" fill="#333">Natural frequency:  ωₙ = √(kt/J)</text>
        <text x={20} y={H-24} fontSize="10" fill="#555">Damping ratio:  ζ = ct / (2√(kt·J))</text>

        {/* ── Panel 2: Cross-section & twist ── */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Shaft Cross-Sections and Torsional Stiffness</text>

        {(() => {
          const sections = [
            { label:'Solid Circle', shape:'circle', r:30, col:'#c0392b',
              kt:'kt = GJ/L\nJ = πd⁴/32', cx:PW+78 },
            { label:'Hollow Circle', shape:'annulus', ro:30, ri:18, col:'#2E75B6',
              kt:'J = π(do⁴-di⁴)/32', cx:PW+210 },
            { label:'Solid Rectangle', shape:'rect', w:44, h:26, col:'#27ae60',
              kt:'J ≈ βhb³ (β from table)', cx:PW+360 },
          ];

          return (
            <>
              {sections.map(({ label, shape, r, ro, ri, w, h, col, kt, cx }) => {
                const cy2 = 120;
                return (
                  <g key={label}>
                    {shape==='circle' && (
                      <circle cx={cx} cy={cy2} r={r} fill={col} opacity="0.15"
                        stroke={col} strokeWidth="2"/>
                    )}
                    {shape==='annulus' && (
                      <>
                        <circle cx={cx} cy={cy2} r={ro} fill={col} opacity="0.15"
                          stroke={col} strokeWidth="2"/>
                        <circle cx={cx} cy={cy2} r={ri} fill="#fff" stroke={col}
                          strokeWidth="1.5" strokeDasharray="4,3"/>
                      </>
                    )}
                    {shape==='rect' && (
                      <rect x={cx-w/2} y={cy2-h/2} width={w} height={h}
                        fill={col} opacity="0.15" stroke={col} strokeWidth="2" rx={2}/>
                    )}
                    <text x={cx} y={cy2+52} textAnchor="middle" fontSize="10.5"
                      fill={col} fontWeight="700">{label}</text>
                    {kt.split('\n').map((line,li)=>(
                      <text key={li} x={cx} y={cy2+66+li*14} textAnchor="middle"
                        fontSize="9.5" fill="#555" fontFamily="'Courier New',monospace">{line}</text>
                    ))}
                  </g>
                );
              })}

              {/* Twist visualisation */}
              <text x={PW+20+PW/2} y={192} textAnchor="middle" fontSize="11"
                fill="#7B0D0D" fontWeight="700">Shear Stress Distribution (solid circle)</text>

              {/* Shear stress diagram */}
              {(() => {
                const cx2 = PW+20+PW/2, cy2 = 248, R = 34;
                const stressLines = [];
                for (let deg = 0; deg < 360; deg += 30) {
                  const rad = deg * Math.PI/180;
                  const x1 = cx2 + 4*Math.cos(rad), y1 = cy2 + 4*Math.sin(rad);
                  const x2 = cx2 + R*Math.cos(rad), y2 = cy2 + R*Math.sin(rad);
                  stressLines.push({ x1,y1,x2,y2 });
                }
                return (
                  <>
                    <circle cx={cx2} cy={cy2} r={R} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
                    {stressLines.map((ln,i)=>(
                      <line key={i} x1={ln.x1} y1={ln.y1} x2={ln.x2} y2={ln.y2}
                        stroke="#c0392b" strokeWidth="1.2" opacity="0.5"
                        markerEnd="url(#ta1)"/>
                    ))}
                    <circle cx={cx2} cy={cy2} r={4} fill="#c0392b"/>
                    <text x={cx2+R+6} y={cy2+4} fontSize="10" fill="#c0392b">τ_max = Tc/J</text>
                    <text x={cx2+R+6} y={cy2+18} fontSize="9.5" fill="#555">at outer radius r=c</text>
                    <text x={cx2} y={cy2+R+16} textAnchor="middle" fontSize="9.5"
                      fill="#555">τ(r) = Tr/J  (linear)</text>
                  </>
                );
              })()}
            </>
          );
        })()}
      </svg>
      <div style={S.dCaption}>The SDOF torsional oscillator is the rotational analogue of the linear mass-spring-damper: polar moment of inertia J replaces mass m, torsional stiffness kt replaces linear stiffness k, and angular displacement θ replaces linear displacement x. The equation J·θ̈ + ct·θ̇ + kt·θ = T(t) has identical mathematical form to the translational case — every linear vibration result translates directly. The torsional stiffness of a shaft kt = GIp/L depends on the shear modulus G, polar second moment of area Ip, and length L.</div>
    </div>
  );
}

// ── Diagram 2: Multi-Disk System — 2-DOF and 3-DOF ───────────────
function DiagramMultiDisk() {
  const W = 900, H = 310;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Multi-Disk Torsional Systems — 2-DOF and 3-DOF Lumped Models</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="md1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ── Row 1: 2-DOF system ── */}
        <text x={10} y={20} fontSize="11" fill="#7B0D0D" fontWeight="700">Two-Disk System (2-DOF):</text>

        {(() => {
          const y0 = 80, diskR = 28, shaftY = y0;
          const disks = [{cx:120,J:'J₁',col:'#c0392b'},{cx:370,J:'J₂',col:'#2E75B6'}];
          const shafts = [{x1:148,x2:342,kt:'kt₁₂',col:'#c0392b'}];

          return (
            <>
              {/* Shafts */}
              {shafts.map(({x1,x2,kt,col})=>(
                <g key={kt}>
                  <rect x={x1} y={shaftY-7} width={x2-x1} height={14} rx={7}
                    fill="#eee" stroke="#bbb" strokeWidth="1.5"/>
                  {/* coil spring lines */}
                  {Array.from({length:6},(_,i)=>{
                    const x = x1+20+i*((x2-x1-40)/5);
                    return <line key={i} x1={x} y1={shaftY-7} x2={x+8} y2={shaftY+7}
                      stroke={col} strokeWidth="1.5" opacity="0.6"/>;
                  })}
                  <text x={(x1+x2)/2} y={shaftY-14} textAnchor="middle"
                    fontSize="10.5" fill={col} fontWeight="700">{kt}</text>
                </g>
              ))}

              {/* Disks */}
              {disks.map(({cx,J,col})=>(
                <g key={J}>
                  <ellipse cx={cx} cy={y0} rx={20} ry={diskR} fill={col} opacity="0.18"
                    stroke={col} strokeWidth="2.5"/>
                  <text x={cx} y={y0+5} textAnchor="middle" fontSize="12"
                    fill={col} fontWeight="700">{J}</text>
                </g>
              ))}

              {/* θ annotations */}
              {disks.map(({cx,J,col},i)=>(
                <g key={i}>
                  <path d={`M${cx+20},${y0-20} A 24 28 0 0 1 ${cx+20},${y0+20}`}
                    fill="none" stroke={col} strokeWidth="1.5" markerEnd="url(#md1)"/>
                  <text x={cx+30} y={y0+6} fontSize="10" fill={col} fontWeight="700">θ{i+1}</text>
                </g>
              ))}

              {/* Equations of motion */}
              <rect x={430} y={30} width={456} height={96} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
              <text x={438} y={48} fontSize="10.5" fill="#7B0D0D" fontWeight="700">Equations of motion (undamped):</text>
              <text x={438} y={64} fontSize="10" fill="#c0392b" fontFamily="'Courier New',monospace">J₁θ̈₁ + kt₁₂(θ₁ − θ₂) = T₁</text>
              <text x={438} y={80} fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">J₂θ̈₂ + kt₁₂(θ₂ − θ₁) = T₂</text>
              <text x={438} y={96} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">[J]θ̈ + [K]θ = T</text>
              <text x={438} y={112} fontSize="9.5" fill="#555">Characteristic eq: det([K] − ω²[J]) = 0</text>
              <text x={438} y={124} fontSize="9.5" fill="#555">ω₁² = 0 (rigid body);  ω₂² = kt(1/J₁ + 1/J₂)</text>
            </>
          );
        })()}

        {/* Divider */}
        <line x1={10} y1={148} x2={890} y2={148} stroke="#f0cece" strokeWidth="1.5" strokeDasharray="6,4"/>
        <text x={10} y={165} fontSize="11" fill="#7B0D0D" fontWeight="700">Three-Disk System (3-DOF)  — Typical Drivetrain Model:</text>

        {(() => {
          const y0 = 225, diskR = 26;
          const disks = [
            {cx:80,  J:'J₁', col:'#c0392b', lbl:'Engine'},
            {cx:260, J:'J₂', col:'#e07b00', lbl:'Gearbox'},
            {cx:440, J:'J₃', col:'#2E75B6', lbl:'Propeller'},
          ];
          const shafts = [
            {x1:100,x2:240,kt:'kt₁₂',col:'#c0392b'},
            {x1:280,x2:420,kt:'kt₂₃',col:'#e07b00'},
          ];

          return (
            <>
              {shafts.map(({x1,x2,kt,col})=>(
                <g key={kt}>
                  <rect x={x1} y={y0-6} width={x2-x1} height={12} rx={6}
                    fill="#eee" stroke="#bbb" strokeWidth="1.5"/>
                  {Array.from({length:5},(_,i)=>{
                    const x = x1+16+i*((x2-x1-32)/4);
                    return <line key={i} x1={x} y1={y0-6} x2={x+7} y2={y0+6}
                      stroke={col} strokeWidth="1.5" opacity="0.6"/>;
                  })}
                  <text x={(x1+x2)/2} y={y0-14} textAnchor="middle"
                    fontSize="10" fill={col} fontWeight="700">{kt}</text>
                </g>
              ))}

              {disks.map(({cx,J,col,lbl})=>(
                <g key={J}>
                  <ellipse cx={cx} cy={y0} rx={18} ry={diskR} fill={col} opacity="0.18"
                    stroke={col} strokeWidth="2.5"/>
                  <text x={cx} y={y0+4} textAnchor="middle" fontSize="11"
                    fill={col} fontWeight="700">{J}</text>
                  <text x={cx} y={y0+diskR+14} textAnchor="middle"
                    fontSize="9.5" fill={col}>{lbl}</text>
                </g>
              ))}

              {/* Mode shapes bar */}
              <rect x={500} y={162} width={386} height={136} rx={4} fill="#fff" stroke="#f0cece"/>
              <text x={693} y={178} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">3-DOF Natural Frequencies</text>
              {[
                {y:192, col:'#27ae60', label:'Mode 1: ω₁=0', desc:'Rigid-body rotation — all disks same phase'},
                {y:216, col:'#c0392b', label:'Mode 2: ω₂', desc:'J₁ vs (J₂+J₃) — one node on shaft 1-2'},
                {y:240, col:'#2E75B6', label:'Mode 3: ω₃', desc:'J₁+J₂ vs J₃ — one node on shaft 2-3'},
                {y:264, col:'#888',    label:'Node count', desc:'Mode r has (r−1) nodes; mode 1 has 0'},
              ].map(({y,col,label,desc})=>(
                <g key={y}>
                  <rect x={506} y={y} width={374} height={22} rx={2}
                    fill={y===192?'#f0fff4':y===216?'#fff5f5':y===240?'#eaf3ff':'#f9f9f9'}/>
                  <text x={512} y={y+15} fontSize="10" fill={col} fontWeight="700">{label}</text>
                  <text x={640} y={y+15} fontSize="9.5" fill="#555">{desc}</text>
                </g>
              ))}
            </>
          );
        })()}
      </svg>
      <div style={S.dCaption}>Multi-disk torsional systems are modelled by lumping each rotating component (flywheel, gear, propeller, turbine disk) as a rigid inertia J connected by massless elastic shafts with stiffness kt. An n-disk system has n degrees of freedom and n natural frequencies. The lowest is always zero — corresponding to rigid-body rotation of the whole system — and the remaining n−1 are the torsional resonances. The mode shapes describe the relative twist amplitude at each disk, with the rth mode having r−1 nodes (points of zero relative twist).</div>
    </div>
  );
}

// ── Diagram 3: Mode Shapes ────────────────────────────────────────
function DiagramModeShapes() {
  const W = 900, H = 330;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torsional Mode Shapes — 3-Disk System and Node Identification</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ms1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Three mode shape panels */}
        {[
          {
            i:0, label:'Mode 1  (ω₁ = 0) — Rigid-Body Rotation',
            col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            shapes:[1.0, 1.0, 1.0],
            desc:'All disks rotate in same direction\nNo relative twist — zero strain energy\nNot a vibration mode in practice (translation of whole system)',
          },
          {
            i:1, label:'Mode 2  (ω₂) — First Elastic Mode',
            col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
            shapes:[1.0, 0.3, -0.8],
            desc:'Disk 1 and Disk 3 move in opposite directions\nOne node between disks 2 and 3\nMost critical for drivetrain fatigue',
          },
          {
            i:2, label:'Mode 3  (ω₃) — Second Elastic Mode',
            col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
            shapes:[1.0, -1.4, 0.6],
            desc:'Two sign changes — one node near disk 1-2 shaft\nand one near disk 2-3 shaft\nHigher frequency; less excited in typical operation',
          },
        ].map(({ i, label, col, bg, bc, shapes, desc }) => {
          const panW = (W - 16) / 3;
          const px = 8 + i * (panW + 4);
          const py = 8;
          const diskXs = [px + panW*0.2, px + panW*0.5, px + panW*0.8];
          const baseY = py + 120;
          const scale = 60;

          return (
            <g key={i}>
              <rect x={px} y={py} width={panW} height={H-16} rx={5} fill={bg} stroke={bc} strokeWidth="1.5"/>
              <rect x={px} y={py} width={panW} height={26} rx={4} fill={bc}/>
              <text x={px+panW/2} y={py+17} textAnchor="middle" fontSize="10.5"
                fill="#fff" fontWeight="700">{label}</text>

              {/* Zero line */}
              <line x1={px+10} y1={baseY} x2={px+panW-10} y2={baseY}
                stroke="#ccc" strokeWidth="1.5" strokeDasharray="4,3"/>

              {/* Shaft connections */}
              {[0,1].map(j=>(
                <line key={j} x1={diskXs[j]} y1={baseY - shapes[j]*scale}
                  x2={diskXs[j+1]} y2={baseY - shapes[j+1]*scale}
                  stroke={col} strokeWidth="2" strokeDasharray="4,2" opacity="0.5"/>
              ))}

              {/* Mode shape line through disks */}
              {(() => {
                // Smooth interpolation points
                const pts = diskXs.map((x, k) => `${x},${baseY - shapes[k]*scale}`).join(' ');
                return <polyline points={pts} fill="none" stroke={col} strokeWidth="2.5"/>;
              })()}

              {/* Disk markers */}
              {diskXs.map((x, k) => (
                <g key={k}>
                  <ellipse cx={x} cy={baseY - shapes[k]*scale} rx={10} ry={14}
                    fill={col} opacity="0.25" stroke={col} strokeWidth="2"/>
                  <text x={x} y={baseY - shapes[k]*scale + 5} textAnchor="middle"
                    fontSize="9.5" fill={col} fontWeight="700">J{k+1}</text>
                  {/* Amplitude value */}
                  <text x={x} y={baseY - shapes[k]*scale - 18} textAnchor="middle"
                    fontSize="9" fill={col}>{shapes[k].toFixed(1)}</text>
                </g>
              ))}

              {/* Node markers (zero crossings) */}
              {shapes.slice(0,-1).map((s,j)=>{
                const s2 = shapes[j+1];
                if (s * s2 < 0) {
                  // Node between disk j and j+1
                  const t = Math.abs(s) / (Math.abs(s) + Math.abs(s2));
                  const nx = diskXs[j] + t*(diskXs[j+1]-diskXs[j]);
                  return (
                    <g key={j}>
                      <circle cx={nx} cy={baseY} r={5} fill="#fff" stroke={col}
                        strokeWidth="2"/>
                      <text x={nx} y={baseY+16} textAnchor="middle"
                        fontSize="9" fill={col} fontWeight="700">NODE</text>
                    </g>
                  );
                }
                return null;
              })}

              {/* Description */}
              {desc.split('\n').map((line,li)=>(
                <text key={li} x={px+8} y={py+220+li*18} fontSize="9.5" fill="#555">{line}</text>
              ))}

              {/* Shaft labels */}
              <text x={diskXs[0]} y={py+H-52} textAnchor="middle" fontSize="9" fill={col}>Disk 1</text>
              <text x={diskXs[1]} y={py+H-52} textAnchor="middle" fontSize="9" fill={col}>Disk 2</text>
              <text x={diskXs[2]} y={py+H-52} textAnchor="middle" fontSize="9" fill={col}>Disk 3</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Mode shapes describe the relative angular displacement of each disk at a natural frequency. The amplitude at each disk is normalised — only the shape matters, not the absolute magnitude. Nodes are points of zero relative displacement: a shaft section spanning a node experiences maximum dynamic twist (shear stress), making nodes the critical fatigue locations. Mode 2 of a 3-disk system has one node; mode 3 has two nodes. The rigid-body mode (all disks in phase, zero frequency) represents neutral rotation and carries no strain energy.</div>
    </div>
  );
}

// ── Diagram 4: Free and Forced Response Plots ─────────────────────
function DiagramResponse() {
  const W = 900, H = 360;
  const PW = (W - 30) / 2;

  // Free decay: θ(t) = θ₀ e^(-ζωₙt) cos(ωd t)
  const N = 200;
  const tMax = 12, wn = 2.5, zeta = 0.08;
  const wd = wn * Math.sqrt(1 - zeta*zeta);
  const tFree = Array.from({length:N},(_,i)=>i/(N-1)*tMax);
  const yFree = tFree.map(t => Math.exp(-zeta*wn*t)*Math.cos(wd*t));
  const envPos = tFree.map(t => Math.exp(-zeta*wn*t));
  const envNeg = tFree.map(t => -Math.exp(-zeta*wn*t));

  // Forced response: steady-state amplitude vs r for torsional system
  const nR = 300;
  const rVals = Array.from({length:nR},(_,i)=>0.05+i/(nR-1)*2.95);
  const zetas2 = [
    {z:0.05, col:'#c0392b', label:'ζ=0.05'},
    {z:0.2,  col:'#e07b00', label:'ζ=0.20'},
    {z:0.5,  col:'#2E75B6', label:'ζ=0.50'},
  ];
  const amp = (r,z) => 1/Math.sqrt((1-r*r)**2+(2*z*r)**2);

  const ox1=14, oy1=230, ow1=PW-28, oh1=180;
  const toX1 = (t) => ox1 + (t/tMax)*ow1;
  const toY1 = (v) => oy1 - v*oh1*0.45;

  const padL=52, padR=14, padT=38, plotH=210, plotW=PW-padL-padR-6;
  const ox2 = PW+20+padL, oy2 = padT+plotH;
  const toX2 = r => ox2+(r-0.05)/2.95*plotW;
  const toY2 = v => oy2 - Math.min(v/10,1)*plotH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torsional Response — Free Decay and Forced Frequency Response</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="rp1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Free decay */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Free Torsional Vibration — Damped Decay</text>
        <text x={10+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">θ(t) = θ₀ e^(−ζωₙt) cos(ωd t),   ζ=0.08,  ωₙ=2.5 rad/s</text>

        {/* Axes */}
        <line x1={ox1} y1={oy1+6} x2={ox1+ow1+10} y2={oy1+6} stroke="#888" strokeWidth="1.5" markerEnd="url(#rp1)"/>
        <line x1={ox1} y1={oy1+6} x2={ox1} y2={oy1-oh1*0.5-10} stroke="#888" strokeWidth="1.5" markerEnd="url(#rp1)"/>
        <text x={ox1+ow1+14} y={oy1+10} fontSize="10" fill="#555">t (s)</text>
        <text x={ox1-8} y={oy1-oh1*0.47} fontSize="10" fill="#555">θ</text>

        {/* Zero line */}
        <line x1={ox1} y1={oy1} x2={ox1+ow1} y2={oy1} stroke="#eee" strokeWidth="1"/>

        {/* Envelope lines */}
        <polyline points={tFree.map((t,i)=>`${toX1(t)},${toY1(envPos[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.6"/>
        <polyline points={tFree.map((t,i)=>`${toX1(t)},${toY1(envNeg[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.6"/>

        {/* Free decay curve */}
        <polyline points={tFree.map((t,i)=>`${toX1(t)},${toY1(yFree[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Period annotation */}
        {(() => {
          const Td = 2*Math.PI/wd;
          const x1 = toX1(0.5), x2 = toX1(0.5+Td);
          const y = oy1 - oh1*0.5 + 12;
          return (
            <>
              <line x1={x1} y1={y} x2={x2} y2={y} stroke="#2E75B6" strokeWidth="1.5" markerEnd="url(#rp1)"/>
              <line x1={x1} y1={y-4} x2={x1} y2={y+4} stroke="#2E75B6" strokeWidth="1.5"/>
              <text x={(x1+x2)/2} y={y-6} textAnchor="middle" fontSize="9.5" fill="#2E75B6" fontWeight="700">Td = 2π/ωd</text>
            </>
          );
        })()}

        {/* Log decrement annotation */}
        {(() => {
          // find successive peaks
          const pk1t = Math.PI/wd*0, pk2t = 2*Math.PI/wd;
          const pk1y = Math.exp(-zeta*wn*0);
          const pk2y = Math.exp(-zeta*wn*pk2t);
          const x1 = toX1(0), x2 = toX1(pk2t);
          const yy1 = toY1(pk1y), yy2 = toY1(pk2y);
          return (
            <>
              <circle cx={x1} cy={yy1} r={4} fill="#27ae60"/>
              <circle cx={x2} cy={yy2} r={4} fill="#27ae60"/>
              <line x1={x1+4} y1={yy1} x2={x2-4} y2={yy2} stroke="#27ae60"
                strokeWidth="1" strokeDasharray="3,2"/>
              <text x={(x1+x2)/2+14} y={(yy1+yy2)/2-4} fontSize="9" fill="#27ae60" fontWeight="700">δ=ln(θₙ/θₙ₊₁)</text>
              <text x={(x1+x2)/2+14} y={(yy1+yy2)/2+8} fontSize="9" fill="#27ae60">ζ = δ/(2π)</text>
            </>
          );
        })()}

        {/* t-axis ticks */}
        {[0,2,4,6,8,10,12].map(t=>(
          <text key={t} x={toX1(t)} y={oy1+18} textAnchor="middle" fontSize="9" fill="#aaa">{t}</text>
        ))}

        {/* Info box */}
        <rect x={14} y={H-80} width={PW-20} height={64} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={20} y={H-66} fontSize="10" fill="#7B0D0D" fontWeight="700">Log decrement method:</text>
        <text x={20} y={H-52} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">δ = ln(θₙ/θₙ₊ₘ)/m  (m cycles apart)</text>
        <text x={20} y={H-38} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">ζ = δ / √(4π² + δ²)  ≈  δ/(2π)</text>
        <text x={20} y={H-24} fontSize="9.5" fill="#555">ωd = ωₙ√(1−ζ²);  T_d = 2π/ωd</text>

        {/* Panel 2: Frequency response (amplitude vs r) */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Forced Torsional Response — Amplitude vs. Frequency Ratio</text>
        <text x={PW+20+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">|Θ/Θ_st| = 1/√[(1−r²)²+(2ζr)²]</text>

        {/* Grid */}
        {[0,2,4,6,8,10].map(v=>{
          const y=toY2(v);
          return (
            <g key={v}>
              <line x1={ox2} y1={y} x2={ox2+plotW} y2={y} stroke="#f5f5f5" strokeWidth="1"/>
              <text x={ox2-4} y={y+4} textAnchor="end" fontSize="9" fill="#aaa">{v}</text>
            </g>
          );
        })}
        {[0.5,1,1.5,2,2.5,3].map(r=>{
          const x=toX2(r);
          return (
            <g key={r}>
              <line x1={x} y1={padT} x2={x} y2={oy2} stroke="#f0f0f0" strokeWidth={r===1?1.5:1}/>
              <text x={x} y={oy2+13} textAnchor="middle" fontSize="9" fill="#aaa">{r}</text>
            </g>
          );
        })}

        {/* Curves */}
        {zetas2.map(({z,col,label})=>{
          const pts = rVals.map(r=>`${toX2(r)},${toY2(Math.min(amp(r,z),10))}`).join(' ');
          return <polyline key={z} points={pts} fill="none" stroke={col} strokeWidth="2.2"/>;
        })}

        {/* Axes */}
        <line x1={ox2} y1={padT} x2={ox2} y2={oy2+4} stroke="#888" strokeWidth="1.5"/>
        <line x1={ox2} y1={oy2} x2={ox2+plotW+8} y2={oy2} stroke="#888" strokeWidth="1.5" markerEnd="url(#rp1)"/>
        <text x={ox2+plotW/2} y={oy2+26} textAnchor="middle" fontSize="10" fill="#555">Frequency Ratio r = ω/ωₙ</text>
        <text x={ox2-20} y={padT+plotH/2} fontSize="9.5" fill="#555"
          transform={`rotate(-90,${ox2-20},${padT+plotH/2})`} textAnchor="middle">|Θ/Θ_st|</text>

        {/* r=1 peak annotation */}
        {(() => {
          const x=toX2(1), y=toY2(Math.min(1/(2*0.05),10));
          return (
            <>
              <line x1={x} y1={y+4} x2={x+50} y2={y-12} stroke="#c0392b"
                strokeWidth="1" strokeDasharray="3,2"/>
              <text x={x+52} y={y-14} fontSize="9.5" fill="#c0392b" fontWeight="700">Peak = 1/(2ζ)</text>
            </>
          );
        })()}

        {/* Legend */}
        {zetas2.map(({col,label},i)=>(
          <g key={i}>
            <line x1={ox2+8} y1={H-94+i*18} x2={ox2+28} y2={H-94+i*18} stroke={col} strokeWidth="2.2"/>
            <text x={ox2+32} y={H-90+i*18} fontSize="9.5" fill={col} fontWeight="700">{label}</text>
          </g>
        ))}

        {/* Resonance info box */}
        <rect x={ox2} y={H-50} width={plotW} height={34} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={ox2+6} y={H-36} fontSize="9.5" fill="#7B0D0D" fontWeight="700">At resonance r=1: Θ_peak = T₀/(2ζkt)  — limited only by damping</text>
        <text x={ox2+6} y={H-22} fontSize="9.5" fill="#555">Power input = Power dissipated;  phase lag = 90° exactly at resonance</text>
      </svg>
      <div style={S.dCaption}>Free torsional vibration decays exponentially — the envelope follows e^(−ζωₙt). The logarithmic decrement δ = ln(θₙ/θₙ₊₁) is the standard experimental method for extracting damping from a free-decay time record. Forced response peaks at r = 1 with amplitude 1/(2ζ) times the static twist — identical in form to the linear oscillator. At resonance the phase of the twist lags the applied torque by exactly 90°, and all input power goes into damping dissipation.</div>
    </div>
  );
}

// ── Diagram 5: Drivetrain / Powertrain System ─────────────────────
function DiagramDrivetrain() {
  const W = 900, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Automotive Drivetrain Torsional Model — Engine to Wheels</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="dt1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Components from left to right */}
        {(() => {
          const y0 = 120, shaftY = y0;

          const components = [
            { type:'disk', cx:60,   J:'J_e',  label:'Engine\ncrank',  col:'#c0392b', r:28 },
            { type:'flex', cx:130,  label:'Flexible\ncoupling', col:'#e07b00' },
            { type:'disk', cx:200,  J:'J_fw', label:'Flywheel',        col:'#c0392b', r:36 },
            { type:'shaft',cx:265,  label:'Prop\nshaft',   col:'#888' },
            { type:'disk', cx:330,  J:'J_gb', label:'Gearbox\ninertia', col:'#e07b00', r:22 },
            { type:'gear', cx:400,  label:'Gear\npair n:1', col:'#9b59b6' },
            { type:'disk', cx:480,  J:'J_ps', label:'Prop\nshaft',     col:'#2E75B6', r:20 },
            { type:'shaft',cx:548,  label:'Drive\nshaft',  col:'#888' },
            { type:'disk', cx:620,  J:'J_w',  label:'Wheel &\ntyre',   col:'#2E75B6', r:30 },
            { type:'ground',cx:720, label:'Road\nimpedance', col:'#555' },
          ];

          const shaftSegments = [
            {x1:88,x2:122,col:'#c0392b',kt:'kt_e'},
            {x1:178,x2:242,col:'#c0392b',kt:'kt_fw'},
            {x1:222,x2:308,col:'#888',   kt:'kt_ps1'},
            {x1:352,x2:378,col:'#e07b00',kt:'kt_g'},
            {x1:422,x2:460,col:'#2E75B6',kt:'kt_ps2'},
            {x1:500,x2:590,col:'#2E75B6',kt:'kt_ds'},
            {x1:650,x2:700,col:'#555',   kt:'kt_tyre'},
          ];

          return (
            <>
              {/* Shaft segments */}
              {shaftSegments.map(({x1,x2,col,kt})=>(
                <g key={kt}>
                  <rect x={x1} y={shaftY-5} width={x2-x1} height={10}
                    rx={5} fill="#eee" stroke="#bbb" strokeWidth="1"/>
                  {Array.from({length:4},(_,i)=>{
                    const x = x1+8+i*((x2-x1-16)/3);
                    return <line key={i} x1={x} y1={shaftY-5} x2={x+5} y2={shaftY+5}
                      stroke={col} strokeWidth="1" opacity="0.7"/>;
                  })}
                  <text x={(x1+x2)/2} y={shaftY-12} textAnchor="middle"
                    fontSize="8.5" fill={col} fontWeight="700">{kt}</text>
                </g>
              ))}

              {/* Disks / components */}
              {components.map(({ type, cx, J, label, col, r=20 }) => {
                if (type === 'disk') return (
                  <g key={cx}>
                    <ellipse cx={cx} cy={y0} rx={r*0.45} ry={r} fill={col}
                      opacity="0.2" stroke={col} strokeWidth="2"/>
                    <text x={cx} y={y0+4} textAnchor="middle" fontSize="9"
                      fill={col} fontWeight="700">{J}</text>
                    {label.split('\n').map((ln,li)=>(
                      <text key={li} x={cx} y={y0+r+14+li*12} textAnchor="middle"
                        fontSize="8.5" fill={col}>{ln}</text>
                    ))}
                  </g>
                );
                if (type === 'flex') return (
                  <g key={cx}>
                    <rect x={cx-10} y={y0-18} width={20} height={36} rx={4}
                      fill="#fff9e6" stroke={col} strokeWidth="2" strokeDasharray="4,2"/>
                    <text x={cx} y={y0+30} textAnchor="middle" fontSize="8" fill={col}>Flex</text>
                  </g>
                );
                if (type === 'gear') return (
                  <g key={cx}>
                    {/* Two meshing gears */}
                    <circle cx={cx-10} cy={y0-8} r={14} fill="#f8f0ff"
                      stroke={col} strokeWidth="1.5"/>
                    <circle cx={cx+10} cy={y0+8} r={10} fill="#f8f0ff"
                      stroke={col} strokeWidth="1.5"/>
                    <text x={cx} y={y0+34} textAnchor="middle" fontSize="8" fill={col}>n:1</text>
                  </g>
                );
                if (type === 'ground') return (
                  <g key={cx}>
                    <rect x={cx-20} y={y0-18} width={40} height={36} rx={3}
                      fill="#f0f0f0" stroke="#555" strokeWidth="1.5" strokeDasharray="3,2"/>
                    <text x={cx} y={y0+4} textAnchor="middle" fontSize="9"
                      fill="#555" fontWeight="700">Road</text>
                    {[-12,-4,4,12].map(dy=>(
                      <line key={dy} x1={cx-18} y1={y0+dy} x2={cx-28} y2={y0+dy+8}
                        stroke="#bbb" strokeWidth="1"/>
                    ))}
                  </g>
                );
                return null;
              })}

              {/* Excitation arrow (engine orders) */}
              <line x1={60} y1={y0-44} x2={60} y2={y0-30} stroke="#c0392b" strokeWidth="2" markerEnd="url(#dt1)"/>
              <text x={60} y={y0-48} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">Engine orders</text>
              <text x={60} y={y0-56} textAnchor="middle" fontSize="8.5" fill="#c0392b">nω₀/2 (4-stroke)</text>
            </>
          );
        })()}

        {/* Key issues panel */}
        <rect x={10} y={194} width={880} height={96} rx={4} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={212} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Critical Torsional Issues in Drivetrains</text>
        {[
          { x:20,  col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
            lines:['Engine Excitation', 'Orders: n/2, n, 3n/2…', 'for n-cylinder 4-stroke'] },
          { x:170, col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
            lines:['Gear Rattle', 'Low torque → backlash', 'impact → noise/wear'] },
          { x:320, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
            lines:['Critical Speed', 'Engine order crosses', 'torsional resonance'] },
          { x:470, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            lines:['Flexible Coupling', 'Detunes resonance,', 'adds damping'] },
          { x:620, col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6',
            lines:['Gear Ratio Effect', 'Refer inertias/stiffs', 'to one shaft: J\' = n²J'] },
          { x:770, col:'#555',    bg:'#f5f5f5', bc:'#888',
            lines:['Tyre Damping', 'Significant at low f', 'reduces road input'] },
        ].map(({ x, col, bg, bc, lines }) => (
          <g key={x}>
            <rect x={x} y={220} width={142} height={64} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={x+6} y={234} fontSize="9.5" fill={col} fontWeight="700">{lines[0]}</text>
            <text x={x+6} y={248} fontSize="9" fill="#555">{lines[1]}</text>
            <text x={x+6} y={261} fontSize="9" fill="#555">{lines[2]}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The automotive drivetrain is a chain of torsional inertias linked by elastic shafts, flexible couplings, and gear pairs. The engine generates torque fluctuations at multiples of half the rotation frequency (engine orders). When an engine order coincides with a torsional natural frequency — a critical speed — large oscillations can cause fatigue failures, gear rattle, or driveline noise. Gear pairs change effective inertia and stiffness values when referred to a common shaft: J_referred = n²J_actual where n is the gear ratio.</div>
    </div>
  );
}

// ── Diagram 6: Holzer's Method Table ─────────────────────────────
function DiagramHolzer() {
  const W = 900, H = 300;

  // Holzer method for 3-disk system
  // J = [1, 2, 1.5], kt = [4, 3] (normalised units)
  // Trial frequency ω = 1.8 rad/s (near mode 2)
  const J  = [1.0, 2.0, 1.5];
  const kt = [4.0, 3.0];
  const omega = 1.8;
  const w2 = omega * omega;

  // Holzer table: assume θ₁=1, θ̇₁=0
  // For each disk i: Σ(J_i θ_i ω²) from i=1
  // Inertia torque Ti = sum(J_j ω² θ_j, j=1..i)
  // θ_i+1 = θ_i - Ti/kt_i
  const rows = [];
  let thetas = [1.0];
  let sumJw2th = J[0] * w2 * 1.0;

  rows.push({
    i:1, theta:1.0, Jw2th: J[0]*w2*1.0,
    sumJw2th: J[0]*w2*1.0,
    kt: kt[0], dtheta: (J[0]*w2*1.0)/kt[0]
  });

  let th2 = 1.0 - (J[0]*w2*1.0)/kt[0];
  thetas.push(th2);
  sumJw2th += J[1]*w2*th2;
  rows.push({
    i:2, theta:th2, Jw2th: J[1]*w2*th2,
    sumJw2th: sumJw2th,
    kt: kt[1], dtheta: sumJw2th/kt[1]
  });

  let th3 = th2 - sumJw2th/kt[1];
  thetas.push(th3);
  const finalSum = sumJw2th + J[2]*w2*th3;
  rows.push({
    i:3, theta:th3, Jw2th: J[2]*w2*th3,
    sumJw2th: finalSum,
    kt: '—', dtheta: '—'
  });

  const colW = [46, 60, 80, 90, 100, 70, 80];
  const headers = ['Disk\ni', 'J_i', 'θᵢ (trial)', 'Jᵢω²θᵢ', 'ΣJω²θ (torque)', 'kt_i', 'Δθᵢ = ΣT/k'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Holzer Method — Numerical Natural Frequency Calculation (Trial ω = 1.8 rad/s)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left: method explanation */}
        <rect x={10} y={10} width={310} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={165} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Holzer Algorithm</text>

        {[
          { y:40,  col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
            step:'① Assume θ₁ = 1.0',
            desc:'Trial amplitude at first disk;\nall other θᵢ will be calculated' },
          { y:96,  col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
            step:'② Calc inertia torques',
            desc:'Tᵢ = Jᵢ·ω²·θᵢ\nfor each disk i = 1,2,…,n' },
          { y:152, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
            step:'③ Accumulate shear torque',
            desc:'ΣT = Σⱼ₌₁ⁱ Jⱼ·ω²·θⱼ\n(torque transmitted through shaft)' },
          { y:208, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            step:'④ Calc next twist',
            desc:'θᵢ₊₁ = θᵢ − ΣT / ktᵢ\n(compatibility of twist)' },
          { y:255, col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6',
            step:'⑤ Check residual',
            desc:'At last disk: ΣT_n must = 0\nfor a natural frequency\nIf ΣT_n ≠ 0, try new ω' },
        ].map(({ y, col, bg, bc, step, desc }) => (
          <g key={y}>
            <rect x={16} y={y} width={298} height={52} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={22} y={y+14} fontSize="10.5" fill={col} fontWeight="700">{step}</text>
            {desc.split('\n').map((line,li)=>(
              <text key={li} x={22} y={y+28+li*14} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}

        {/* Right: Holzer table */}
        <rect x={328} y={10} width={560} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={608} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">
          Holzer Table: J=[1,2,1.5], kt=[4,3], ω={omega} rad/s
        </text>
        <text x={608} y={42} textAnchor="middle" fontSize="9.5" fill="#555">
          Residual torque ΣT_last = {finalSum.toFixed(4)} (non-zero → not a natural frequency)
        </text>

        {/* Table header */}
        {headers.map((h, ci) => {
          const cx2 = 334 + colW.slice(0,ci).reduce((a,b)=>a+b,0);
          return (
            <g key={ci}>
              <rect x={cx2} y={52} width={colW[ci]-1} height={28} fill="#c0392b"/>
              {h.split('\n').map((line,li)=>(
                <text key={li} x={cx2+4} y={52+16+li*10} fontSize="9.5"
                  fill="#fff" fontWeight="700">{line}</text>
              ))}
            </g>
          );
        })}

        {/* Table rows */}
        {rows.map((row, ri) => {
          const rowY = 80 + ri*42;
          const bg = ri%2===0 ? '#fff5f5' : '#fff';
          const vals = [
            row.i,
            J[ri].toFixed(1),
            typeof row.theta === 'number' ? row.theta.toFixed(4) : row.theta,
            typeof row.Jw2th === 'number' ? row.Jw2th.toFixed(4) : row.Jw2th,
            typeof row.sumJw2th === 'number' ? row.sumJw2th.toFixed(4) : row.sumJw2th,
            row.kt,
            typeof row.dtheta === 'number' ? row.dtheta.toFixed(4) : row.dtheta,
          ];
          return (
            <g key={ri}>
              {vals.map((v, ci) => {
                const cx2 = 334 + colW.slice(0,ci).reduce((a,b)=>a+b,0);
                const isResidual = ri===2 && ci===4;
                return (
                  <g key={ci}>
                    <rect x={cx2} y={rowY} width={colW[ci]-1} height={40}
                      fill={isResidual ? '#fff9c4' : bg} stroke="#f0cece" strokeWidth="0.5"/>
                    <text x={cx2+4} y={rowY+24} fontSize="10"
                      fill={isResidual?'#c0392b':ci===0?'#7B0D0D':'#333'}
                      fontFamily="'Courier New',monospace"
                      fontWeight={ci===0||isResidual?'700':'400'}>{String(v)}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Residual sweep hint */}
        <rect x={334} y={210} width={548} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={340} y={226} fontSize="10.5" fill="#7B0D0D" fontWeight="700">Residual torque vs. trial ω — find zero crossings:</text>
        {/* Mini sketch of residual curve */}
        {(() => {
          const ox=340, oy=266, ow=200, oh=34;
          const omegas = Array.from({length:60},(_,i)=>0.1+i/59*3.5);
          // Approximate residual for this system (zero near ω≈0 and ω≈2.1)
          const residuals = omegas.map(w => {
            const w2=w*w;
            let th=[1.0];
            let sum=J[0]*w2*1.0;
            const th2=1-sum/kt[0]; th.push(th2);
            sum+=J[1]*w2*th2;
            const th3=th2-sum/kt[1]; th.push(th3);
            return sum+J[2]*w2*th3;
          });
          const rmax=Math.max(...residuals.map(Math.abs));
          const pts=omegas.map((w,i)=>`${ox+(w/3.5)*ow},${oy-residuals[i]/rmax*oh/2}`).join(' ');
          return (
            <>
              <line x1={ox} y1={oy} x2={ox+ow} y2={oy} stroke="#bbb" strokeWidth="1"/>
              <polyline points={pts} fill="none" stroke="#c0392b" strokeWidth="2"/>
              <text x={ox+ow+4} y={oy+4} fontSize="9" fill="#888">ω →</text>
              <text x={ox} y={oy+14} fontSize="9" fill="#555">Zero crossings = natural frequencies</text>
            </>
          );
        })()}
        <text x={554} y={226} fontSize="9.5" fill="#333">Sweep ω from low to high;</text>
        <text x={554} y={240} fontSize="9.5" fill="#333">sign change of ΣT_last brackets a root.</text>
        <text x={554} y={254} fontSize="9.5" fill="#333">Bisection or Newton method refines it.</text>
      </svg>
      <div style={S.dCaption}>Holzer's method is a transfer-matrix technique for finding torsional natural frequencies without assembling global matrices. Starting with an assumed unit amplitude at the first disk and a trial frequency ω, it propagates the twist and torque through the system disk by disk. At the last disk, the residual torque ΣT must equal zero for ω to be a natural frequency. By sweeping ω and watching for sign changes in the residual, all natural frequencies can be bracketed and refined iteratively.</div>
    </div>
  );
}

// ── Diagram 7: Shear Stress and Fatigue in Shafts ────────────────
function DiagramStressFatigue() {
  const W = 900, H = 310;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torsional Shear Stress, Fatigue, and Critical Speed Diagram</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="sf1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
          <marker id="sf2" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Panel 1: Shear stress distribution + failure */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Shear Stress Distribution and Failure Modes</text>

        {(() => {
          const cx = 10+PW/2 - 60, cy = 130, R = 50;
          return (
            <>
              {/* Shaft cross-section */}
              <circle cx={cx} cy={cy} r={R} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>

              {/* Radial stress gradient arrows (longer = higher stress) */}
              {Array.from({length:8},(_,i)=>{
                const angle = i/8 * 2*Math.PI;
                const rInner=8, rOuter=R-4;
                const x1=cx+rInner*Math.cos(angle), y1=cy+rInner*Math.sin(angle);
                const x2=cx+rOuter*Math.cos(angle), y2=cy+rOuter*Math.sin(angle);
                const arrowLen = rOuter-rInner;
                // Colour by magnitude (linear with r)
                const intensity = Math.round(255 - (rOuter/R)*200);
                return (
                  <line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
                    stroke={`rgb(192,57,43)`} strokeWidth="2" opacity={(rOuter/R)*0.9}
                    markerEnd="url(#sf2)"/>
                );
              })}

              {/* Centre dot */}
              <circle cx={cx} cy={cy} r={6} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
              <text x={cx} y={cy+4} textAnchor="middle" fontSize="8" fill="#c0392b">τ=0</text>

              {/* τ_max annotation */}
              <text x={cx+R+6} y={cy-4} fontSize="10.5" fill="#c0392b" fontWeight="700">τ_max = Tc/Ip</text>
              <text x={cx+R+6} y={cy+10} fontSize="9.5" fill="#555">at outer surface r=c</text>
              <text x={cx+R+6} y={cy+24} fontSize="9.5" fill="#555">τ(r) = Tr/Ip (linear)</text>

              {/* Stress profile bar */}
              {(() => {
                const bx = cx-R-70, by = cy-R;
                return (
                  <>
                    <line x1={bx} y1={by} x2={bx} y2={by+2*R} stroke="#888" strokeWidth="1.5" markerEnd="url(#sf1)"/>
                    <line x1={bx} y1={by+2*R} x2={bx+60} y2={by+2*R} stroke="#888" strokeWidth="1.5" markerEnd="url(#sf1)"/>
                    {/* Linear profile */}
                    <path d={`M${bx},${by+2*R} L${bx+54},${by}`} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
                    <text x={bx+58} y={by+4} fontSize="9.5" fill="#c0392b" fontWeight="700">τ_max</text>
                    <text x={bx+4} y={by+2*R-4} fontSize="9.5" fill="#c0392b">0</text>
                    <text x={bx-16} y={by+R+4} fontSize="9" fill="#888">r→</text>
                  </>
                );
              })()}

              {/* Failure modes */}
              {[
                { y:210, col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
                  title:'Ductile shear failure',
                  desc:'τ_max > τ_yield → 45° helical crack\nMaterial yields in shear on maximum shear plane' },
                { y:260, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
                  title:'Fatigue failure (torsional)',
                  desc:'Alternating τ → fatigue crack at stress riser\nKeyways, notches, shoulders reduce fatigue life' },
              ].map(({ y, col, bg, bc, title, desc }) => (
                <g key={y}>
                  <rect x={14} y={y} width={PW-20} height={46} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
                  <text x={20} y={y+14} fontSize="10.5" fill={col} fontWeight="700">{title}</text>
                  {desc.split('\n').map((line,li)=>(
                    <text key={li} x={20} y={y+28+li*13} fontSize="9.5" fill="#333">{line}</text>
                  ))}
                </g>
              ))}
            </>
          );
        })()}

        {/* Panel 2: Critical speed diagram (interference diagram) */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Interference Diagram — Critical Speeds</text>
        <text x={PW+20+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">Engine order lines vs. torsional natural frequencies</text>

        {(() => {
          const ox=PW+36, oy=240, ow=PW-50, oh=180;
          const rpmMax=4000, fMax=120;

          // Natural frequency horizontal lines (independent of RPM)
          const fn = [18, 48, 92]; // Hz
          const fnCols = ['#c0392b','#e07b00','#2E75B6'];

          // Engine order lines: f = n * RPM/60
          const orders = [0.5, 1, 1.5, 2, 3, 4, 6];
          const orderCols = { 0.5:'#ddd', 1:'#bbb', 1.5:'#aaa', 2:'#888', 3:'#666', 4:'#555', 6:'#444' };

          const toX = rpm => ox + (rpm/rpmMax)*ow;
          const toY = f   => oy - (f/fMax)*oh;

          // Find crossings
          const crossings = [];
          fn.forEach((f,fi)=>{
            orders.forEach(ord=>{
              const rpm = f / ord * 60;
              if (rpm > 200 && rpm < rpmMax) {
                crossings.push({ rpm, f, fi, ord });
              }
            });
          });

          return (
            <>
              {/* Grid */}
              {[0,20,40,60,80,100,120].map(f=>{
                const y=toY(f);
                return (
                  <g key={f}>
                    <line x1={ox} y1={y} x2={ox+ow} y2={y} stroke="#f5f5f5" strokeWidth="1"/>
                    <text x={ox-4} y={y+4} textAnchor="end" fontSize="9" fill="#aaa">{f}</text>
                  </g>
                );
              })}
              {[0,1000,2000,3000,4000].map(rpm=>{
                const x=toX(rpm);
                return (
                  <g key={rpm}>
                    <line x1={x} y1={oy-oh} x2={x} y2={oy} stroke="#f5f5f5" strokeWidth="1"/>
                    <text x={x} y={oy+12} textAnchor="middle" fontSize="9" fill="#aaa">{rpm}</text>
                  </g>
                );
              })}

              {/* Order lines */}
              {orders.map(ord=>{
                const x2=toX(rpmMax), y2=toY(ord*rpmMax/60);
                const clampY = y2 < toY(fMax) ? toY(fMax) : y2;
                const clampX = y2 < toY(fMax) ? ox+(fMax*60/ord)/rpmMax*ow : x2;
                return (
                  <line key={ord} x1={ox} y1={oy} x2={clampX} y2={clampY}
                    stroke={orderCols[ord]} strokeWidth={ord===1||ord===2?1.8:1}
                    strokeDasharray={ord===1?'none':'4,3'}/>
                );
              })}
              {/* Order labels */}
              {[1,2,3,4].map(ord=>{
                const rpmL = Math.min(rpmMax*0.9, fMax*60/ord*0.9);
                const x=toX(rpmL), y=toY(ord*rpmL/60)-8;
                if (y < toY(fMax)-4 || y > oy) return null;
                return <text key={ord} x={x} y={y} fontSize="9" fill={orderCols[ord]}>{ord}×</text>;
              })}

              {/* Natural frequency lines */}
              {fn.map((f, fi)=>(
                <g key={fi}>
                  <line x1={ox} y1={toY(f)} x2={ox+ow} y2={toY(f)}
                    stroke={fnCols[fi]} strokeWidth="2.2"/>
                  <text x={ox+ow+4} y={toY(f)+4} fontSize="9.5"
                    fill={fnCols[fi]} fontWeight="700">fₙ{fi+1}={f}Hz</text>
                </g>
              ))}

              {/* Critical speed markers */}
              {crossings.slice(0,6).map(({ rpm, f, fi, ord }, ci) => (
                <g key={ci}>
                  <circle cx={toX(rpm)} cy={toY(f)} r={5}
                    fill="#fff" stroke={fnCols[fi]} strokeWidth="2"/>
                  <text x={toX(rpm)} y={toY(f)-8} textAnchor="middle"
                    fontSize="8" fill={fnCols[fi]} fontWeight="700">{Math.round(rpm)}</text>
                </g>
              ))}

              {/* Axes */}
              <line x1={ox} y1={oy-oh-8} x2={ox} y2={oy+4} stroke="#888" strokeWidth="1.5"/>
              <line x1={ox} y1={oy} x2={ox+ow+8} y2={oy} stroke="#888" strokeWidth="1.5" markerEnd="url(#sf1)"/>
              <text x={ox+ow/2} y={oy+24} textAnchor="middle" fontSize="10" fill="#555">Engine Speed (RPM)</text>
              <text x={ox-24} y={oy-oh/2} fontSize="9.5" fill="#555"
                transform={`rotate(-90,${ox-24},${oy-oh/2})`} textAnchor="middle">Frequency (Hz)</text>

              {/* Legend */}
              <line x1={ox} y1={oy-oh-28} x2={ox+20} y2={oy-oh-28} stroke="#c0392b" strokeWidth="2.2"/>
              <text x={ox+24} y={oy-oh-24} fontSize="9" fill="#c0392b">Natural freq. lines</text>
              <line x1={ox+100} y1={oy-oh-28} x2={ox+120} y2={oy-oh-28} stroke="#888" strokeWidth="1.5" strokeDasharray="4,2"/>
              <text x={ox+124} y={oy-oh-24} fontSize="9" fill="#888">Engine order lines</text>
              <circle cx={ox+220} cy={oy-oh-28} r={5} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
              <text x={ox+228} y={oy-oh-24} fontSize="9" fill="#c0392b">Critical speed</text>
            </>
          );
        })()}
      </svg>
      <div style={S.dCaption}>The torsional shear stress is zero at the shaft centreline and maximum at the outer radius — making surface defects (keyways, notches, shoulders) the critical initiation sites for fatigue cracks. The interference diagram plots engine order lines (f = n × RPM/60) and torsional natural frequencies on the same frequency-vs-speed axes. Every intersection is a critical speed where the engine excitation matches a resonance. The diagram guides the designer to avoid sustained operation at critical speeds or to add damping to limit the resonance amplitude.</div>
    </div>
  );
}

// ── Diagram 8: Control and Mitigation Strategies ──────────────────
function DiagramMitigation() {
  const W = 900, H = 270;
  const strategies = [
    {
      title:'Torsional Damper\n(Viscous)',
      col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
      icon:'≈',
      lines:[
        'Fluid-filled annular chamber',
        'Inertia ring shears viscous fluid',
        'Broadband — damps all modes',
        'Used: crankshaft front damper',
        'ct_eff = c_fluid; Q-factor reduced',
      ],
    },
    {
      title:'Tuned Torsional\nAbsorber (DVA)',
      col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
      icon:'⟳',
      lines:[
        'Secondary inertia + torsional spring',
        'Tuned to primary torsional mode',
        'Creates anti-resonance at target ω',
        'Used: camshaft, geartrain',
        'Narrow-band — retune if fₙ changes',
      ],
    },
    {
      title:'Flexible Coupling\n(Elastomeric)',
      col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
      icon:'◈',
      lines:[
        'Soft rubber element in torque path',
        'Lowers torsional stiffness → lower fₙ',
        'Shifts resonance below idle speed',
        'η ≈ 0.1–0.3 inherent damping',
        'Jaw, disk, tyre, Oldham couplings',
      ],
    },
    {
      title:'Shaft Redesign\n(Geometry)',
      col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
      icon:'⊘',
      lines:[
        'Change d → modify kt = GIp/L',
        'Longer shaft → softer → lower fₙ',
        'Hollow shaft: same Ip, less mass J',
        'Avoids critical speeds by detuning',
        'Remove stress risers (smooth fillets)',
      ],
    },
    {
      title:'Active Torsional\nControl',
      col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6',
      icon:'⚡',
      lines:[
        'Torque actuator (motor/generator)',
        'Feedback from torsional sensor',
        'Injects counter-torque at resonance',
        'Used: hybrid powertrains, wind turbines',
        'Requires real-time control electronics',
      ],
    },
    {
      title:'Gear / Speed\nScheduling',
      col:'#555', bg:'#f5f5f5', bc:'#888',
      icon:'⚙',
      lines:[
        'Avoid running at critical RPM',
        'Rapid transient through resonance',
        'Barred speed ranges in control system',
        'Used: marine diesels, turbines',
        'Does not reduce dynamic loads',
      ],
    },
  ];

  const cardW = (W - 20) / 3, cardH = 130;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torsional Vibration Mitigation Strategies</div>
      <svg viewBox={`0 0 ${W} 270`} style={{ width:'100%', display:'block' }}>
        {strategies.map(({ title, col, bg, bc, icon, lines }, i) => {
          const c = i % 3, r = Math.floor(i / 3);
          const x = 8 + c*(cardW+3), y = 8 + r*(cardH+6);
          return (
            <g key={i}>
              <rect x={x} y={y} width={cardW} height={cardH} rx={5}
                fill={bg} stroke={bc} strokeWidth="1.5"/>
              <rect x={x} y={y} width={cardW} height={26} rx={4} fill={bc}/>
              <text x={x+cardW/2-10} y={y+17} textAnchor="middle" fontSize="11.5"
                fill="#fff" fontWeight="700">{title.replace('\n',' ')}</text>
              <text x={x+cardW-10} y={y+20} textAnchor="end" fontSize="18"
                fill="#fff" opacity="0.3">{icon}</text>
              {lines.map((line, li) => (
                <text key={li} x={x+8} y={y+40+li*17} fontSize="9.5" fill="#333">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Torsional vibration mitigation falls into four categories: passive damping (viscous torsional dampers dissipate energy across all frequencies), tuned absorption (DVA creates a local anti-resonance at the target frequency), detuning (flexible couplings or shaft redesign shift natural frequencies away from excitation orders), and avoidance (barred speed ranges). Active control is increasingly used in hybrid powertrains where the electric motor can inject a counter-torque in real time. In practice, most machines use a combination: a flexible coupling to detune plus a viscous damper to handle residual resonance.</div>
    </div>
  );
}

// ── Diagram 9: Continuous Shaft — Distributed Parameter Model ────
function DiagramContinuousShaft() {
  const W = 900, H = 310;
  const PW = (W - 30) / 2;

  // Mode shapes of a free-free shaft: cos(nπx/L), n=1,2,3
  const N = 100;
  const xVals = Array.from({length:N},(_,i)=>i/(N-1));

  const modes = [
    {n:1, col:'#c0392b', fn:'n=1:  fₙ₁ = (1/2L)√(G/ρ)', label:'Mode 1'},
    {n:2, col:'#e07b00', fn:'n=2:  fₙ₂ = 2·fₙ₁',        label:'Mode 2'},
    {n:3, col:'#2E75B6', fn:'n=3:  fₙ₃ = 3·fₙ₁',        label:'Mode 3'},
  ];

  const ox=14, oy=200, ow=PW-28, oh=140;
  const toX = x => ox+x*ow;
  const toY = v => oy-v*oh*0.42;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Continuous Shaft — Distributed Parameter Model and Wave Equation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="cs1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Mode shapes of free-free shaft */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Free-Free Shaft Mode Shapes</text>
        <text x={10+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">φₙ(x) = cos(nπx/L)  — free-free boundary conditions</text>

        {/* Shaft outline */}
        <rect x={ox} y={oy-oh*0.42-14} width={ow} height={6} rx={3} fill="#ddd" stroke="#bbb" strokeWidth="1"/>

        {/* Axes */}
        <line x1={ox} y1={oy+6} x2={ox+ow+10} y2={oy+6} stroke="#888" strokeWidth="1.5" markerEnd="url(#cs1)"/>
        <line x1={ox} y1={oy+6} x2={ox} y2={oy-oh*0.42-20} stroke="#888" strokeWidth="1.5" markerEnd="url(#cs1)"/>
        <text x={ox+ow+14} y={oy+10} fontSize="10" fill="#555">x/L</text>
        <text x={ox-8} y={oy-oh*0.38} fontSize="10" fill="#555">φ</text>

        {/* Zero line */}
        <line x1={ox} y1={oy} x2={ox+ow} y2={oy} stroke="#eee" strokeWidth="1.5"/>

        {modes.map(({n,col,fn,label})=>{
          const pts = xVals.map(x=>`${toX(x)},${toY(Math.cos(n*Math.PI*x))}`).join(' ');
          return (
            <g key={n}>
              <polyline points={pts} fill="none" stroke={col} strokeWidth="2.2"/>
            </g>
          );
        })}

        {/* x-axis labels */}
        {[0,0.25,0.5,0.75,1.0].map(x=>(
          <text key={x} x={toX(x)} y={oy+18} textAnchor="middle" fontSize="9" fill="#aaa">{x}</text>
        ))}

        {/* Node markers */}
        {/* Mode 2 has a node at x=0.5 */}
        <circle cx={toX(0.5)} cy={oy} r={4} fill="#fff" stroke="#e07b00" strokeWidth="2"/>
        <text x={toX(0.5)} y={oy+28} textAnchor="middle" fontSize="9" fill="#e07b00">node (n=2)</text>
        {/* Mode 3 nodes at x=1/3, 2/3 */}
        {[1/3,2/3].map(x=>(
          <circle key={x} cx={toX(x)} cy={oy} r={4} fill="#fff" stroke="#2E75B6" strokeWidth="2"/>
        ))}

        {/* Legend */}
        {modes.map(({col,fn},i)=>(
          <g key={i}>
            <line x1={ox+8} y1={H-74+i*22} x2={ox+28} y2={H-74+i*22} stroke={col} strokeWidth="2.2"/>
            <text x={ox+32} y={H-70+i*22} fontSize="9.5" fill={col} fontWeight="700">{fn}</text>
          </g>
        ))}

        {/* BC note */}
        <rect x={14} y={H-28} width={PW-20} height={16} rx={2} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={20} y={H-16} fontSize="9.5" fill="#7B0D0D" fontWeight="700">Fixed-free: φₙ=cos((2n-1)πx/(2L));  fₙ=(2n-1)c/(4L);  c=√(G/ρ)</text>

        {/* Panel 2: Wave equation and theory */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Wave Equation and Dispersion</text>

        {[
          { y:38,  col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
            title:'Torsional Wave Equation',
            lines:['GIp·∂²θ/∂x² = ρIp·∂²θ/∂t²',
                   'Simplifies to: c²·∂²θ/∂x² = ∂²θ/∂t²',
                   'Wave speed:  c = √(G/ρ)  [m/s]'] },
          { y:116, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
            title:'Natural Frequencies (free-free)',
            lines:['fₙ = n·c/(2L),  n = 1,2,3,...',
                   'c = √(G/ρ)  (torsional wave speed)',
                   'Steel: G=80 GPa, ρ=7800 kg/m³ → c≈3200 m/s'] },
          { y:194, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            title:'Boundary Conditions',
            lines:['Free end:  ∂θ/∂x = 0  (zero shear stress)',
                   'Fixed end: θ = 0  (zero displacement)',
                   'Free-free: modes at n=1,2,3...',
                   'Fixed-free: modes at n=0.5,1.5,2.5...'] },
          { y:272, col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
            title:'Lumped vs. Continuous',
            lines:['Lumped: accurate below 5th mode',
                   'Continuous: full spectrum; needs BCs',
                   'FEM: best for complex geometry'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={PW+26} y={y} width={PW-14} height={lines.length*16+22} rx={3}
              fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={PW+32} y={y+15} fontSize="10.5" fill={col} fontWeight="700">{title}</text>
            {lines.map((line,li)=>(
              <text key={li} x={PW+32} y={y+30+li*16} fontSize="9.5" fill="#333"
                fontFamily="'Courier New',monospace">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The distributed-parameter (continuous) shaft model governs torsional wave propagation by the equation c²·∂²θ/∂x² = ∂²θ/∂t², where c = √(G/ρ) is the torsional wave speed. Natural frequencies are harmonics of c/(2L) for free-free boundaries. The continuous model predicts an infinite set of natural frequencies — for practical drivetrains, only the first few (below the operating speed range) are relevant, justifying the lumped-parameter approximation used in Holzer's method and mass-matrix models.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function TorsionalVibrations() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Torsional Vibrations</h1>
      <p style={S.p}>
        Torsional vibration is the oscillatory twisting of shafts and rotating components about their own axis. It arises in every machine that transmits torque — engines, turbines, pumps, compressors, gearboxes, and drivetrains — wherever the applied torque fluctuates periodically or where the system has natural torsional frequencies that can be excited. Unlike lateral (bending) vibration, torsional vibration is largely invisible without specialised instrumentation, yet it is responsible for a significant proportion of rotating machinery failures: crankshaft fractures, gear rattle, driveline clunk, and turbine blade fatigue. The mathematical framework is directly parallel to the linear vibration of a mass-spring-damper, with polar moment of inertia J replacing mass, torsional stiffness kt replacing linear stiffness, and angular displacement θ replacing linear displacement.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Torsional EOM: J·θ̈ + ct·θ̇ + kt·θ = T(t) — identical form to mẍ + cẋ + kx = F(t)",
        "Torsional stiffness of a circular shaft: kt = GIp/L where G = shear modulus, Ip = polar second moment of area, L = length",
        "Natural frequency: ωₙ = √(kt/J);  static twist: θ_st = T₀/kt;  resonance amplitude: T₀/(2ζkt)",
        "Multi-disk systems: one zero frequency (rigid-body rotation) + n−1 elastic torsional natural frequencies",
        "Engine excitation orders: multiples of 1/2 × shaft frequency for a 4-stroke (half-order, full-order, 1.5-order...)",
        "Critical speed: RPM at which an engine order line intersects a torsional natural frequency — dangerous sustained operation",
        "Holzer method: numerical transfer-matrix sweep to find all torsional natural frequencies without assembling global matrices",
        "Shear stress: τ(r) = Tr/Ip — linear with radius, maximum at surface; τ_max = Tc/Ip (c = outer radius)",
        "Continuous shaft wave speed: c = √(G/ρ); free-free natural frequencies: fₙ = n·c/(2L)",
        "Mitigation: viscous torsional dampers (broadband), flexible couplings (detune fₙ), DVA (narrowband cancellation), barred speed ranges",
      ]} />

      <h2 style={S.h2}>SDOF Torsional Oscillator</h2>
      <p style={S.p}>
        The simplest torsional model consists of a single rigid disk (polar inertia J) attached to a massless elastic shaft (torsional stiffness kt) with viscous damping ct. This is the rotational analogue of the linear SDOF oscillator, and every result from linear vibration theory — natural frequency, damping ratio, resonance, impulse response, step response — carries over directly by substituting the torsional quantities.
      </p>
      <DiagramSDOFTorsion />
      <Table2 rows={[
        ["Torsional stiffness kt", "kt = GIp/L   [N·m/rad]\nG = shear modulus (Pa);  Ip = polar 2nd moment of area (m⁴);  L = shaft length (m)\nSolid circle: Ip = πd⁴/32;  Hollow: Ip = π(do⁴−di⁴)/32"],
        ["Polar moment of inertia J", "J = ∫r² dm   [kg·m²]\nSolid disk: J = mR²/2;  Hollow disk: J = m(R₁²+R₂²)/2\nAnnular ring, spoke wheel: sum contributions from each element"],
        ["Natural frequency ωₙ", "ωₙ = √(kt/J)  [rad/s];   fₙ = ωₙ/(2π)  [Hz]\nIncreasing shaft stiffness raises fₙ;  increasing disk inertia lowers fₙ\nDesign lever: change L or d to tune fₙ away from excitation orders"],
        ["Damping ratio ζ", "ζ = ct / (2√(ktJ)) = ct/(2Jωₙ)\nζ < 1: underdamped (most rotating machines)\nTypical values: ζ = 0.01–0.05 (lightly damped shafts)"],
        ["Static angular deflection", "θ_st = T₀/kt  [rad]\nDynamic magnification factor Q = 1/(2ζ) at resonance\nθ_peak = θ_st / (2ζ)  — can be many times the static twist"],
        ["Equivalent viscous damping", "Structural damping model: ct = η·kt/ωₙ  (frequency-proportional)\nHysteretic loss factor η ≈ 0.01–0.1 for engineering materials\nEquivalent ζ_eq = η/2 (at resonance frequency)"],
        ["Torsional impulse response", "θ(t) = (T_imp/Jωd) e^(−ζωₙt) sin(ωd t)   for t ≥ 0\nT_imp = impulse torque [N·m·s];  ωd = ωₙ√(1−ζ²)\nUsed to interpret sudden torque spikes (clutch engagement, short circuit)"],
      ]} />

      <h2 style={S.h2}>Multi-Disk Torsional Systems</h2>
      <p style={S.p}>
        Real machines are modelled as chains of rigid disks connected by elastic shaft segments. Each disk has a polar inertia Jᵢ and each shaft segment has a stiffness ktᵢ. The system equations are assembled into matrix form [J]θ̈ + [K]θ = T, where [K] is the torsional stiffness matrix and [J] is the diagonal inertia matrix.
      </p>
      <DiagramMultiDisk />
      <Table2 rows={[
        ["Stiffness matrix [K]", "[K] is tridiagonal for a linear chain:\nK_ii = kt_{i-1} + kt_i;  K_{i,i±1} = −kt_i\nDeterminant of [K] = 0 (always singular — one zero eigenvalue = rigid-body mode)"],
        ["Eigenvalue problem", "det([K] − ω²[J]) = 0\nFor n disks: n eigenvalues ω₁²,…,ωₙ²\nω₁ = 0 always;  ω₂,...,ωₙ are the n−1 elastic natural frequencies"],
        ["Two-disk system", "ω₁ = 0 (rigid-body);  ω₂² = kt(1/J₁ + 1/J₂) = kt(J₁+J₂)/(J₁J₂)\nMode 2: J₁θ₁ + J₂θ₂ = 0 (angular momentum conserved)\nNode location on shaft: x_node/L = J₁/(J₁+J₂)"],
        ["Three-disk system", "Three modes: ω₁=0, ω₂, ω₃\nMode 2 has 1 node; Mode 3 has 2 nodes\nHolzer method or matrix eigenvalue solver finds exact frequencies"],
        ["Gear pairs in the chain", "Refer all inertias to one shaft: J_ref = n²·J_other (n = gear ratio)\nRefer stiffness: kt_ref = n²·kt_other\nAfter reduction, system is equivalent linear chain on one shaft"],
        ["Model reduction", "For practical analysis, use only modes below max operating frequency\nCraig-Bampton substructuring for complex gear systems\nAdded flexibility of gear mesh: kt_mesh from tooth stiffness and contact ratio"],
        ["Orthogonality", "Mode shapes are orthogonal with respect to both [J] and [K]:\nφᵢᵀ[J]φⱼ = δᵢⱼ (mass-normalised);  φᵢᵀ[K]φⱼ = ωᵢ²δᵢⱼ\nAllows uncoupled modal equations: q̈ᵢ + 2ζᵢωᵢq̇ᵢ + ωᵢ²qᵢ = fᵢ(t)"],
      ]} />

      <h2 style={S.h2}>Mode Shapes and Nodes</h2>
      <p style={S.p}>
        Mode shapes describe the pattern of relative angular displacement at each natural frequency. They are the eigenvectors of the eigenvalue problem and are orthogonal with respect to the inertia and stiffness matrices. The node locations — points of zero relative twist — are the critical stress locations during torsional resonance.
      </p>
      <DiagramModeShapes />
      <Table2 rows={[
        ["Node definition", "A node is a point of zero amplitude in a mode shape\nThe shaft section at a node experiences maximum dynamic shear stress\n(maximum relative twist between adjacent disks — like an antinode for stress)"],
        ["Node counting rule", "Mode r has exactly r−1 nodes for a free-free system\nMore nodes = higher frequency mode\nRigid-body mode (mode 1) has zero nodes"],
        ["Node location formula", "Two-disk: node at x/L = J₁/(J₁+J₂) from disk 1 end\nMulti-disk: requires numerical solution (Holzer iteration)\nNode moves toward heavier inertia"],
        ["Amplitude normalisation", "Mode shapes are determined up to an arbitrary scale factor\nCommon: φ₁ = 1.0 (first disk amplitude = 1)\nMass-normalised: φᵀJφ = 1 → modal mass = 1, modal stiffness = ωₙ²"],
        ["Modal superposition", "θ(t) = Σ φᵣ qᵣ(t)  (sum of mode contributions)\nqᵣ(t) is the modal coordinate — satisfies uncoupled SDOF equation\nForced response: compute each qᵣ then sum physically"],
        ["Participation factor", "Γᵣ = φᵣᵀ J {1} (how much mode r is excited by uniform torque)\nHigh Γᵣ → mode easily excited by that input distribution\nZero for modes not in the input path"],
      ]} />

      <h2 style={S.h2}>Free and Forced Torsional Response</h2>
      <p style={S.p}>
        The free torsional response of a damped system decays exponentially. The forced response exhibits resonance when the excitation frequency matches a natural frequency, producing angular amplitudes limited only by the damping. Both responses are directly analogous to the linear oscillator and use the same solution methods.
      </p>
      <DiagramResponse />
      <Table2 rows={[
        ["Free response", "θ(t) = e^(−ζωₙt)[A cos(ωd t) + B sin(ωd t)]\nωd = ωₙ√(1−ζ²)  (damped natural frequency)\nInitial conditions: A = θ₀;  B = (θ̇₀ + ζωₙθ₀)/ωd"],
        ["Log decrement", "δ = ln(θₙ/θₙ₊ₘ)/m  (m complete oscillations apart)\nζ = δ/√(4π²+δ²)  ≈  δ/(2π)  for small ζ\nExtracted from free-decay time record — standard experimental damping method"],
        ["Steady-state forced response", "θ(t) = (T₀/kt) · H(r) · sin(ωt − φ)\nH(r) = 1/√[(1−r²)²+(2ζr)²];  r = ω/ωₙ\nφ = arctan(2ζr/(1−r²))  — phase lag"],
        ["Resonance conditions", "At r=1: H = 1/(2ζ);  φ = 90°;  power in = power dissipated\nPeak occurs at r_peak = √(1−2ζ²) (slightly below r=1)\nHalf-power bandwidth: Δr ≈ 2ζ → Q = 1/(2ζ)"],
        ["Periodic torque (engine)", "T(t) = T₀ + Σ Tₙ cos(nω₀t + φₙ)\nSuperpose SDOF responses for each harmonic n\nCritical when any nω₀ = ωₙ_torsional"],
        ["Transient response", "Clutch engagement, speed transient, short-circuit torque\nConvolution integral: θ(t) = ∫ h(t−τ)·T(τ)dτ\nh(t) = (1/Jωd)e^(−ζωₙt)sin(ωd t)  (impulse response)"],
        ["Torsional fatigue life", "Stress amplitude σ_a from peak dynamic twist θ_dynamic\nMiner's rule: Σ(nᵢ/Nᵢ) = 1  at failure\nReduce by: increasing ζ, avoiding resonance RPM, reducing Tₙ harmonics"],
      ]} />

      <h2 style={S.h2}>Drivetrain Torsional Modelling</h2>
      <p style={S.p}>
        The automotive and marine drivetrain is the most common engineering context for torsional vibration analysis. The engine is a source of periodic torque fluctuations at multiples of shaft frequency; the driveline is a chain of inertias and compliant shafts that can resonate when excited at critical speeds.
      </p>
      <DiagramDrivetrain />
      <Table2 rows={[
        ["Engine torque harmonics", "4-stroke n-cylinder: orders at n/2, n, 3n/2, 2n, ... times crankshaft RPM/60\nMajor orders: n/2 (lowest), n (strongest)\nAmplitudes depend on cylinder pressure history — from indicator diagram"],
        ["Critical speed definition", "Critical speed Ncr = (fₙ / order_number) × 60  [RPM]\nExample: fₙ=30 Hz, 2nd order → Ncr = 30/2 × 60 = 900 RPM\nMultiple criticals for each combination of (mode, order)"],
        ["Interference diagram", "Plot engine order lines (f = order × RPM/60) and natural frequencies\nIntersections = critical speeds\nShaded barred speed ranges where resonance is too severe"],
        ["Gear ratio effect", "Referring to one shaft: J_referred = n²·J_other\nReferred stiffness: kt_referred = n²·kt_other\nNatural frequencies change with engaged gear ratio"],
        ["Marine propulsion specifics", "Very long propeller shafts → low torsional stiffness → low fₙ\nLow-speed diesel: order 0.5–1.0 can excite fₙ in speed range\nClassification rules (DNV, Lloyd's) mandate torsional analysis for new designs"],
        ["Wind turbine drivetrains", "Aerodynamic torque at 1P, 3P (blade passage) excitation\nGearbox: planetary stages introduce gear mesh frequencies\nGenerator can provide active damping via torque control"],
        ["Torsional measurement", "Strain gauge on rotating shaft (telemetry or slip rings)\nEncoder-based (measure angle difference at two cross-sections)\nTorque flange (in-line transducer) — most accurate\nOptical/laser torsionometer for non-contact measurement"],
      ]} />

      <h2 style={S.h2}>Holzer's Method</h2>
      <p style={S.p}>
        Holzer's method is a classical numerical technique for finding the natural frequencies of a multi-disk torsional system. It is a transfer-matrix method that propagates the state (angle and torque) from disk to disk, checking whether the torque boundary condition at the last disk is satisfied. Modern software uses eigenvalue routines, but Holzer's method remains valuable for its physical transparency and ease of manual calculation.
      </p>
      <DiagramHolzer />
      <Table2 rows={[
        ["Transfer matrix form", "State vector {θᵢ, Tᵢ}ᵀ at each station\nDisk transfer: Tᵢ_after = Tᵢ_before − Jᵢω²θᵢ\nShaft transfer: θᵢ₊₁ = θᵢ − Tᵢ/ktᵢ\nOverall: {θₙ,Tₙ} = [Uₙ]···[U₂][U₁]{θ₁,T₁}"],
        ["Boundary conditions", "Free-free: T₁ = 0 and Tₙ = 0\nFixed-free: θ₁ = 0 and Tₙ = 0\nWith T₁=0 and θ₁=1: Tₙ is a function of ω only\nNatural frequency: find ω such that Tₙ(ω) = 0"],
        ["Residual curve", "Plot Tₙ vs ω — sign changes bracket natural frequencies\nSmooth through sign change: bisection to converge\nEach mode gives one zero crossing of Tₙ\nRigid-body mode always at ω=0"],
        ["Mode shape extraction", "Once ωₙᵣ found, run Holzer sweep → obtain all θᵢ\nNormalise: divide all θᵢ by θ₁ = 1 (already done)\nNode locations: where θᵢ changes sign between consecutive disks"],
        ["Accuracy considerations", "Exact for lumped-parameter model (no approximation)\nAccuracy limited by lumping — use more disks for complex geometry\nShaft segment mass: lump half at each end (consistent lumping)\nRefined models include axial + bending coupling for high speeds"],
        ["Computerised Holzer", "Equivalent to multiplying transfer matrices\nFaster: assemble [K] and [J] then call LAPACK eigenvalue routine\nHolzer advantage: physically transparent; easy sensitivity analysis\nChange one Jᵢ or ktᵢ and re-sweep to see frequency shift immediately"],
      ]} />

      <h2 style={S.h2}>Shear Stress, Fatigue, and Critical Speeds</h2>
      <p style={S.p}>
        Torsional vibration matters because it produces oscillating shear stress in shaft cross-sections. When these stresses exceed the material's fatigue limit — particularly at stress concentrations — fatigue cracks initiate and propagate, eventually causing sudden fracture. Understanding where peak stresses occur and when they are excited is the foundation of drivetrain durability design.
      </p>
      <DiagramStressFatigue />
      <Table2 rows={[
        ["Torsional shear stress", "τ(r) = Tr/Ip   [Pa]\nτ_max = Tc/Ip  at outer radius c (or c = d/2 for solid shaft)\nIp = πd⁴/32 (solid);  Ip = π(do⁴−di⁴)/32 (hollow)\nSection modulus: Zp = Ip/c = πd³/16 → τ_max = T/Zp"],
        ["Dynamic amplification of stress", "τ_dynamic = τ_static × Q = τ_static/(2ζ)  at resonance\nζ = 0.02 → Q = 25 → dynamic stress is 25× static stress\nFatigue life determined by τ_alternating (dynamic component)"],
        ["Stress concentration factors", "Keyways: Kt ≈ 1.5–3.0 (depends on r/d ratio)\nShoulders: Kt ≈ 1.3–2.5 (function of r/D and d/D)\nCircumferential grooves: Kt ≈ 2.0–3.5\nEffective stress: τ_eff = Kt × τ_nominal"],
        ["Fatigue failure criterion", "Modified Goodman (torsion): τ_a/τ_f + τ_m/S_u = 1/n\nτ_a = alternating shear amplitude;  τ_m = mean shear stress\nτ_f = endurance limit in torsion ≈ 0.577 × S_e (von Mises)\nSoderberg more conservative: uses S_y instead of S_u"],
        ["45° helical fracture pattern", "Ductile materials: shear yielding on maximum shear planes (axial/transverse)\nBrittle materials: tension failure on 45° helical surface (principal stress direction)\nTwist fractures: brittle materials show classic 45° helical crack"],
        ["Interference diagram usage", "Identify all critical speeds in operating range\nCompute dynamic stress at each critical speed and speed transient\nCompare to Goodman diagram — must have adequate margin\nAdd speed-hold avoidance or damper to meet fatigue life target"],
      ]} />

      <h2 style={S.h2}>Mitigation and Control</h2>
      <p style={S.p}>
        Once torsional resonances and their associated stress levels are identified, the engineer has several tools to bring the system within safe limits: passive dampers, tuned absorbers, flexible couplings that detune the system, geometric redesign of the shaft, and for the most demanding applications, active torque control.
      </p>
      <DiagramMitigation />
      <Table2 rows={[
        ["Viscous torsional damper", "Fluid-filled housing with free-floating inertia ring\nRelative motion between ring and housing shears viscous fluid → energy dissipation\nEffective damping coefficient: ct = 2·ηfluid·(Ip_fluid/gap)\nBroadband — damps all torsional modes simultaneously\nUsed: crankshaft front pulley damper on virtually all automotive engines"],
        ["Rubber torsional damper", "Rubber element in shear between hub and inertia ring\nSimultaneous tuning (spring acts as DVA) and damping\nLoss factor η ≈ 0.1–0.3;  temperature and frequency sensitive\nSmaller and lighter than viscous damper; lower damping effectiveness"],
        ["Elastomeric flexible coupling", "Rubber spider, jaw, tyre, or disc element transmits torque\nLow torsional stiffness → shifts system fₙ to well below idle RPM\nLoss factor η provides inherent damping\nMust be sized for both static and dynamic torque + fatigue"],
        ["Shaft geometry optimisation", "Longer shaft L → lower kt → lower fₙ (often impractical)\nLarger diameter d → higher kt → higher fₙ (increases fₙ away from orders)\nHollow shaft: same Ip with lower mass J → higher fₙ\nSmooth tapers and fillets at shoulders: reduce Kt by factor 2–4"],
        ["Barred speed ranges", "Restrict continuous operation near each critical speed\nIMO/classification rules: barred range ±5–10% of Ncr\nEngine control system enforces minimum ramp-through rate\nNot acceptable for variable-speed systems that must run at all speeds"],
        ["Active torsional damping", "Electric motor/generator in driveline injects counter-torque\nFeedback from encoder angle difference or shaft torque\nHybrid vehicle: use motor torque ripple cancellation\nWind turbine: generator torque setpoint adjusts to damp 1P/3P modes\nRequires fault-tolerant control (passive backup essential)"],
      ]} />

      <h2 style={S.h2}>Continuous Shaft Model</h2>
      <p style={S.p}>
        For long, slender shafts or for high-frequency analysis, the lumped-parameter model becomes inaccurate and the distributed-parameter (continuous) model must be used. The continuous model treats the shaft as an elastic rod with distributed inertia and stiffness, governed by the torsional wave equation.
      </p>
      <DiagramContinuousShaft />
      <Table2 rows={[
        ["Torsional wave equation", "GIp · ∂²θ/∂x² = ρIp · ∂²θ/∂t²\nSimplifies to: c² ∂²θ/∂x² = ∂²θ/∂t²\nc = √(G/ρ)  [m/s] — torsional wave speed"],
        ["Wave speed values", "Steel: G=80 GPa, ρ=7800 kg/m³ → c = √(80e9/7800) ≈ 3200 m/s\nAluminium: G=26 GPa, ρ=2700 kg/m³ → c ≈ 3100 m/s\nRubber coupling: G≈0.5–2 MPa → c ≈ 10–26 m/s (very low!)"],
        ["Free-free natural frequencies", "φₙ(x) = cos(nπx/L);  ωₙ = nπc/L;  fₙ = nc/(2L)\nn = 1, 2, 3, ... (no zero-frequency mode for continuous shaft alone)\nAntinodes at both ends (free ends)"],
        ["Fixed-free natural frequencies", "φₙ(x) = sin((2n−1)πx/(2L))\nωₙ = (2n−1)πc/(2L);  fₙ = (2n−1)c/(4L)\nNode at fixed end;  antinode at free end"],
        ["Lumped vs. continuous", "Lumped (n disks): n natural frequencies\nContinuous: infinite natural frequencies (harmonics)\nLumped accurate to ~10% error for modes below c/(10·L_segment)\nUse ≥ 6 lumps per wavelength for 5% accuracy"],
        ["Finite element torsion", "Each shaft element has 2 DOF (θ at each end)\nElement stiffness: ke = GIp/L · [1 −1; −1 1]\nElement mass (consistent): me = ρIpL/6 · [2 1; 1 2]\nAssemble global [K] and [M]; solve eigenvalue problem"],
        ["Saint-Venant torsion", "Warping allowed: twist per unit length = dφ/dz\nFor non-circular sections: warping stiffness adds stiffness term\nThin-walled open sections: very low torsional stiffness (prone to torsional buckling)\nClosed thin-walled sections: Bredt formula kt = 4A²Gt/(sL) where A = enclosed area"],
      ]} />

      <InfoBox title="Key Formulae Summary" items={[
        "EOM: J·θ̈ + ct·θ̇ + kt·θ = T(t);  ωₙ = √(kt/J);  ζ = ct/(2√(ktJ))",
        "Shaft stiffness: kt = GIp/L;  Ip(solid) = πd⁴/32;  Ip(hollow) = π(do⁴−di⁴)/32",
        "Shear stress: τ(r) = Tr/Ip;  τ_max = Tc/Ip  (c = outer radius);  τ_max = T/Zp  (Zp = Ip/c)",
        "Forced response: |Θ/Θ_st| = 1/√[(1−r²)²+(2ζr)²];  θ_peak = T₀/(2ζkt)  at r=1",
        "Log decrement: δ = ln(θₙ/θₙ₊₁);  ζ ≈ δ/(2π);  ωd = ωₙ√(1−ζ²)",
        "Two-disk: ω₂² = kt(J₁+J₂)/(J₁J₂);  node at x/L = J₁/(J₁+J₂)",
        "Critical speed: Ncr [RPM] = fₙ[Hz] × 60 / order_number",
        "Continuous shaft: c = √(G/ρ);  fₙ = nc/(2L) (free-free);  fₙ = (2n−1)c/(4L) (fixed-free)",
      ]} />
    </div>
  );
}